import { render, staticRenderFns } from "./Withdrawal.vue?vue&type=template&id=5a5cfea0&scoped=true"
import script from "./Withdrawal.vue?vue&type=script&lang=ts"
export * from "./Withdrawal.vue?vue&type=script&lang=ts"
import style0 from "./Withdrawal.vue?vue&type=style&index=0&id=5a5cfea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5cfea0",
  null
  
)

export default component.exports